// // // // // // import { useState, useEffect } from "react";
// // // // // // import {
// // // // // //   Card,
// // // // // //   CardContent,
// // // // // //   Typography,
// // // // // //   Button,
// // // // // //   Box,
// // // // // //   FormControl,
// // // // // //   InputLabel,
// // // // // //   MenuItem,
// // // // // //   Select,
// // // // // //   FormHelperText,
// // // // // //   Alert,
// // // // // // } from "@mui/material";
// // // // // // import axiosClient from "../axiosClient";
// // // // // // import { useStateContext } from "../context/ContextProvider";
// // // // // // import { useTranslation } from "react-i18next";

// // // // // // const Staff = () => {
// // // // // //   const [errors, setErrors] = useState({ client_id: "", staff_id: "" });
// // // // // //   const [selectedClientId, setSelectedClientId] = useState("");
// // // // // //   const [selectedStaffId, setSelectedStaffId] = useState("");
// // // // // //   const [staffUsers, setStaffUsers] = useState([]);
// // // // // //   const [clientUsers, setClientUsers] = useState([]);
// // // // // //   const [message, setMessage] = useState({ text: "", severity: "success" });
// // // // // //   const { token } = useStateContext();
// // // // // //   const { t } = useTranslation();

// // // // // //   useEffect(() => {
// // // // // //     Promise.all([
// // // // // //       axiosClient.get("api/staff-users/"),
// // // // // //       axiosClient.get("api/client-users/"),
// // // // // //     ])
// // // // // //       .then(([staffRes, clientRes]) => {
// // // // // //         setStaffUsers(staffRes?.data || []);
// // // // // //         setClientUsers(clientRes?.data || []);
// // // // // //       })
// // // // // //       .catch((err) => {
// // // // // //         console.error("Error fetching users:", err);
// // // // // //         setMessage({
// // // // // //           text: t("Failed to load users. Please try again."),
// // // // // //           severity: "error",
// // // // // //         });
// // // // // //       });
// // // // // //   }, [t]);

// // // // // //   useEffect(() => {
// // // // // //     if (message.text && message.severity === "success") {
// // // // // //       const timer = setTimeout(() => {
// // // // // //         setMessage({ text: "", severity: "success" });
// // // // // //       }, 5000);
// // // // // //       return () => clearTimeout(timer);
// // // // // //     }
// // // // // //   }, [message]);

// // // // // //   const validateForm = () => {
// // // // // //     const newErrors = { client_id: "", staff_id: "" };
// // // // // //     let isValid = true;

// // // // // //     if (!selectedClientId) {
// // // // // //       newErrors.client_id = t("Patient is required");
// // // // // //       isValid = false;
// // // // // //     }
// // // // // //     if (!selectedStaffId) {
// // // // // //       newErrors.staff_id = t("Doctor is required");
// // // // // //       isValid = false;
// // // // // //     }

// // // // // //     setErrors(newErrors);
// // // // // //     return isValid;
// // // // // //   };

// // // // // //   const handleSubmit = (event) => {
// // // // // //     event.preventDefault();

// // // // // //     if (!validateForm()) {
// // // // // //       return;
// // // // // //     }

// // // // // //     const payload = {
// // // // // //       client_id: selectedClientId,
// // // // // //       staff_id: selectedStaffId,
// // // // // //     };

// // // // // //     axiosClient
// // // // // //       .post("api/assign_client_to_staff/", payload, {
// // // // // //         headers: {
// // // // // //           "Content-Type": "application/json",
// // // // // //           Accept: "*/*",
// // // // // //           Authorization: `JWT ${token}`,
// // // // // //         },
// // // // // //       })
// // // // // //       .then(() => {
// // // // // //         setMessage({
// // // // // //           text: t("Client assigned to staff successfully"),
// // // // // //           severity: "success",
// // // // // //         });
// // // // // //         setSelectedStaffId("");
// // // // // //         setSelectedClientId("");
// // // // // //         setErrors({ client_id: "", staff_id: "" });
// // // // // //       })
// // // // // //       .catch((err) => {
// // // // // //         console.error("Assignment error:", err);
// // // // // //         const errorMessage =
// // // // // //           err.response?.data?.message ||
// // // // // //           err.response?.data?.non_field_errors?.[0] ||
// // // // // //           t("Failed to assign client. Please try again.");
// // // // // //         setMessage({ text: errorMessage, severity: "error" });
// // // // // //       });
// // // // // //   };

// // // // // //   const handleClear = () => {
// // // // // //     setSelectedClientId("");
// // // // // //     setSelectedStaffId("");
// // // // // //     setErrors({ client_id: "", staff_id: "" });
// // // // // //     setMessage({ text: "", severity: "success" });
// // // // // //   };

// // // // // //   return (
// // // // // //     <Card elevation={16}>
// // // // // //       <CardContent>
// // // // // //         <Typography variant="h5" gutterBottom>
// // // // // //           {t("Clients to Staff")}
// // // // // //         </Typography>
// // // // // //         {message.text && (
// // // // // //           <Alert severity={message.severity} sx={{ mb: 2 }}>
// // // // // //             {message.text}
// // // // // //           </Alert>
// // // // // //         )}
// // // // // //         <form onSubmit={handleSubmit}>
// // // // // //           <Box sx={{ "& .MuiFormControl-root": { marginBottom: "1rem" } }}>
// // // // // //             <FormControl fullWidth variant="outlined" error={!!errors.staff_id}>
// // // // // //               <InputLabel id="staff-select-label">{t("Select Staff")}</InputLabel>
// // // // // //               <Select
// // // // // //                 labelId="staff-select-label"
// // // // // //                 value={selectedStaffId}
// // // // // //                 onChange={(e) => setSelectedStaffId(e.target.value)}
// // // // // //                 label={t("Select Staff")}
// // // // // //                 sx={{
// // // // // //                   textAlign: "left",
// // // // // //                   ".MuiSelect-select": {
// // // // // //                     display: "flex",
// // // // // //                     justifyContent: "flex-start",
// // // // // //                   },
// // // // // //                 }}
// // // // // //               >
// // // // // //                 <MenuItem value="">
// // // // // //                   <em>{t("None")}</em>
// // // // // //                 </MenuItem>
// // // // // //                 {staffUsers.map((user) => (
// // // // // //                   <MenuItem key={user.id} value={user.id}>
// // // // // //                     {`${user.custom_user.first_name} ${user.custom_user.last_name}`}
// // // // // //                   </MenuItem>
// // // // // //                 ))}
// // // // // //               </Select>
// // // // // //               {errors.staff_id && (
// // // // // //                 <FormHelperText>{errors.staff_id}</FormHelperText>
// // // // // //               )}
// // // // // //             </FormControl>
// // // // // //             <FormControl fullWidth variant="outlined" error={!!errors.client_id}>
// // // // // //               <InputLabel id="client-select-label">{t("Select Client")}</InputLabel>
// // // // // //               <Select
// // // // // //                 labelId="client-select-label"
// // // // // //                 value={selectedClientId}
// // // // // //                 onChange={(e) => setSelectedClientId(e.target.value)}
// // // // // //                 label={t("Select Client")}
// // // // // //                 sx={{
// // // // // //                   textAlign: "left",
// // // // // //                   ".MuiSelect-select": {
// // // // // //                     display: "flex",
// // // // // //                     justifyContent: "flex-start",
// // // // // //                   },
// // // // // //                 }}
// // // // // //               >
// // // // // //                 <MenuItem value="">
// // // // // //                   <em>{t("None")}</em>
// // // // // //                 </MenuItem>
// // // // // //                 {clientUsers.map((user) => (
// // // // // //                   <MenuItem key={user.id} value={user.id}>
// // // // // //                     {`${user.custom_user.first_name} ${user.custom_user.last_name}`}
// // // // // //                   </MenuItem>
// // // // // //                 ))}
// // // // // //               </Select>
// // // // // //               {errors.client_id && (
// // // // // //                 <FormHelperText>{errors.client_id}</FormHelperText>
// // // // // //               )}
// // // // // //             </FormControl>
// // // // // //           </Box>
// // // // // //           <Box sx={{ display: "flex", gap: 2 }}>
// // // // // //             <Button type="submit" variant="contained" color="primary">
// // // // // //               {t("Submit")}
// // // // // //             </Button>
// // // // // //             <Button variant="outlined" color="secondary" onClick={handleClear}>
// // // // // //               {t("Clear")}
// // // // // //             </Button>
// // // // // //           </Box>
// // // // // //         </form>
// // // // // //       </CardContent>
// // // // // //     </Card>
// // // // // //   );
// // // // // // };

// // // // // // export default Staff;


// // // // // import { useState, useEffect } from "react";
// // // // // import {
// // // // //   Card,
// // // // //   CardContent,
// // // // //   Typography,
// // // // //   Button,
// // // // //   Box,
// // // // //   FormControl,
// // // // //   InputLabel,
// // // // //   MenuItem,
// // // // //   Select,
// // // // //   FormHelperText,
// // // // //   Alert,
// // // // // } from "@mui/material";
// // // // // import axiosClient from "../axiosClient";
// // // // // import { useStateContext } from "../context/ContextProvider";
// // // // // import { useTranslation } from "react-i18next";

// // // // // const Staff = () => {
// // // // //   const [errors, setErrors] = useState({ issue_id: "", technician_id: "" });
// // // // //   const [selectedIssueId, setSelectedIssueId] = useState("");
// // // // //   const [selectedTechnicianId, setSelectedTechnicianId] = useState("");
// // // // //   const [technicians, setTechnicians] = useState([]);
// // // // //   const [issues, setIssues] = useState([]);
// // // // //   const [message, setMessage] = useState({ text: "", severity: "success" });
// // // // //   const { token } = useStateContext();
// // // // //   const { t } = useTranslation();

// // // // //   useEffect(() => {
// // // // //     // ✅ FIXED: Updated to verified backend endpoints
// // // // //     Promise.all([
// // // // //       axiosClient.get("auth/technicians/"), // Fetches Technicians
// // // // //       axiosClient.get("api/issues/"),       // Fetches Issues
// // // // //     ])
// // // // //       .then(([techRes, issueRes]) => {
// // // // //         setTechnicians(techRes?.data || []);
// // // // //         setIssues(issueRes?.data || []);
// // // // //       })
// // // // //       .catch((err) => {
// // // // //         console.error("Error fetching data:", err);
// // // // //         setMessage({
// // // // //           text: t("Failed to load technicians or issues. Please try again."),
// // // // //           severity: "error",
// // // // //         });
// // // // //       });
// // // // //   }, [t]);

// // // // //   useEffect(() => {
// // // // //     if (message.text && message.severity === "success") {
// // // // //       const timer = setTimeout(() => {
// // // // //         setMessage({ text: "", severity: "success" });
// // // // //       }, 5000);
// // // // //       return () => clearTimeout(timer);
// // // // //     }
// // // // //   }, [message]);

// // // // //   const validateForm = () => {
// // // // //     const newErrors = { issue_id: "", technician_id: "" };
// // // // //     let isValid = true;

// // // // //     if (!selectedIssueId) {
// // // // //       newErrors.issue_id = t("Issue is required");
// // // // //       isValid = false;
// // // // //     }
// // // // //     if (!selectedTechnicianId) {
// // // // //       newErrors.technician_id = t("Technician is required");
// // // // //       isValid = false;
// // // // //     }

// // // // //     setErrors(newErrors);
// // // // //     return isValid;
// // // // //   };

// // // // //   const handleSubmit = (event) => {
// // // // //     event.preventDefault();

// // // // //     if (!validateForm()) {
// // // // //       return;
// // // // //     }

// // // // //     const payload = {
// // // // //       issue_id: selectedIssueId,
// // // // //       technician_id: selectedTechnicianId,
// // // // //     };

// // // // //     // ✅ FIXED: Updated to verified assignment endpoint
// // // // //     axiosClient
// // // // //       .post("api/issues/assign/", payload, {
// // // // //         headers: {
// // // // //           "Content-Type": "application/json",
// // // // //           Authorization: `JWT ${token}`,
// // // // //         },
// // // // //       })
// // // // //       .then(() => {
// // // // //         setMessage({
// // // // //           text: t("Issue assigned to technician successfully"),
// // // // //           severity: "success",
// // // // //         });
// // // // //         setSelectedTechnicianId("");
// // // // //         setSelectedIssueId("");
// // // // //         setErrors({ issue_id: "", technician_id: "" });
// // // // //       })
// // // // //       .catch((err) => {
// // // // //         console.error("Assignment error:", err);
// // // // //         setMessage({ 
// // // // //           text: t("Failed to assign. Please ensure the technician is active."), 
// // // // //           severity: "error" 
// // // // //         });
// // // // //       });
// // // // //   };

// // // // //   const handleClear = () => {
// // // // //     setSelectedIssueId("");
// // // // //     setSelectedTechnicianId("");
// // // // //     setErrors({ issue_id: "", technician_id: "" });
// // // // //     setMessage({ text: "", severity: "success" });
// // // // //   };

// // // // //   return (
// // // // //     <Card elevation={16}>
// // // // //       <CardContent>
// // // // //         {/* ✅ Label Updated */}
// // // // //         <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', mb: 3 }}>
// // // // //           {t("TECHNICIAN TO ISSUE")}
// // // // //         </Typography>

// // // // //         {message.text && (
// // // // //           <Alert severity={message.severity} sx={{ mb: 2 }}>
// // // // //             {message.text}
// // // // //           </Alert>
// // // // //         )}

// // // // //         <form onSubmit={handleSubmit}>
// // // // //           <Box sx={{ "& .MuiFormControl-root": { marginBottom: "1.5rem" } }}>
            
// // // // //             {/* ✅ TECHNICIAN SELECT */}
// // // // //             <FormControl fullWidth variant="outlined" error={!!errors.technician_id}>
// // // // //               <InputLabel id="tech-select-label">{t("SELECT TECHNICIAN")}</InputLabel>
// // // // //               <Select
// // // // //                 labelId="tech-select-label"
// // // // //                 value={selectedTechnicianId}
// // // // //                 onChange={(e) => setSelectedTechnicianId(e.target.value)}
// // // // //                 label={t("SELECT TECHNICIAN")}
// // // // //               >
// // // // //                 <MenuItem value=""><em>{t("None")}</em></MenuItem>
// // // // //                 {technicians.map((tech) => (
// // // // //                   <MenuItem key={tech.id} value={tech.id}>
// // // // //                     {/* Accessing nested custom_user based on your model */}
// // // // //                     {tech.first_name ? `${tech.first_name} ${tech.last_name}` : tech.username}
// // // // //                   </MenuItem>
// // // // //                 ))}
// // // // //               </Select>
// // // // //               {errors.technician_id && <FormHelperText>{errors.technician_id}</FormHelperText>}
// // // // //             </FormControl>

// // // // //             {/* ✅ ISSUE SELECT */}
// // // // //             <FormControl fullWidth variant="outlined" error={!!errors.issue_id}>
// // // // //               <InputLabel id="issue-select-label">{t("SELECT ISSUE")}</InputLabel>
// // // // //               <Select
// // // // //                 labelId="issue-select-label"
// // // // //                 value={selectedIssueId}
// // // // //                 onChange={(e) => setSelectedIssueId(e.target.value)}
// // // // //                 label={t("SELECT ISSUE")}
// // // // //               >
// // // // //                 <MenuItem value=""><em>{t("None")}</em></MenuItem>
// // // // //                 {issues.map((issue) => (
// // // // //                   <MenuItem key={issue.id} value={issue.id}>
// // // // //                     {`#${issue.id}: ${issue.title || issue.description?.substring(0, 30)}`}
// // // // //                   </MenuItem>
// // // // //                 ))}
// // // // //               </Select>
// // // // //               {errors.issue_id && <FormHelperText>{errors.issue_id}</FormHelperText>}
// // // // //             </FormControl>

// // // // //           </Box>

// // // // //           <Box sx={{ display: "flex", gap: 2, justifyContent: 'center' }}>
// // // // //             <Button type="submit" variant="contained" color="primary" sx={{ px: 4 }}>
// // // // //               {t("SUBMIT")}
// // // // //             </Button>
// // // // //             <Button variant="outlined" color="secondary" onClick={handleClear} sx={{ px: 4 }}>
// // // // //               {t("RESET")}
// // // // //             </Button>
// // // // //           </Box>
// // // // //         </form>
// // // // //       </CardContent>
// // // // //     </Card>
// // // // //   );
// // // // // };

// // // // // export default Staff;

// // // // import { useState, useEffect } from "react";
// // // // import {
// // // //   Card,
// // // //   CardContent,
// // // //   Typography,
// // // //   Button,
// // // //   Box,
// // // //   FormControl,
// // // //   InputLabel,
// // // //   MenuItem,
// // // //   Select,
// // // //   FormHelperText,
// // // //   Alert,
// // // // } from "@mui/material";
// // // // import axiosClient from "../axiosClient";
// // // // import { useStateContext } from "../context/ContextProvider";
// // // // import { useTranslation } from "react-i18next";

// // // // const Staff = () => {
// // // //   const [errors, setErrors] = useState({ issue_id: "", technician_id: "" });
// // // //   const [selectedIssueId, setSelectedIssueId] = useState("");
// // // //   const [selectedTechnicianId, setSelectedTechnicianId] = useState("");
// // // //   const [technicians, setTechnicians] = useState([]);
// // // //   const [issues, setIssues] = useState([]);
// // // //   const [message, setMessage] = useState({ text: "", severity: "success" });
// // // //   const { token } = useStateContext();
// // // //   const { t } = useTranslation();

// // // //   useEffect(() => {
// // // //     // Fetch data from verified backend endpoints
// // // //     Promise.all([
// // // //       axiosClient.get("auth/technicians/"), 
// // // //       axiosClient.get("api/issues/"),
// // // //     ])
// // // //       .then(([techRes, issueRes]) => {
// // // //         // Log data to console to debug the structure if names still don't show
// // // //         console.log("Technicians Data Received:", techRes.data);
// // // //         setTechnicians(techRes?.data || []);
// // // //         setIssues(issueRes?.data || []);
// // // //       })
// // // //       .catch((err) => {
// // // //         console.error("Error fetching data:", err);
// // // //         setMessage({
// // // //           text: t("Failed to load technicians or issues. Please try again."),
// // // //           severity: "error",
// // // //         });
// // // //       });
// // // //   }, [t]);

// // // //   useEffect(() => {
// // // //     if (message.text && message.severity === "success") {
// // // //       const timer = setTimeout(() => {
// // // //         setMessage({ text: "", severity: "success" });
// // // //       }, 5000);
// // // //       return () => clearTimeout(timer);
// // // //     }
// // // //   }, [message]);

// // // //   const validateForm = () => {
// // // //     const newErrors = { issue_id: "", technician_id: "" };
// // // //     let isValid = true;

// // // //     if (!selectedIssueId) {
// // // //       newErrors.issue_id = t("Issue is required");
// // // //       isValid = false;
// // // //     }
// // // //     if (!selectedTechnicianId) {
// // // //       newErrors.technician_id = t("Technician is required");
// // // //       isValid = false;
// // // //     }

// // // //     setErrors(newErrors);
// // // //     return isValid;
// // // //   };

// // // //   const handleSubmit = (event) => {
// // // //     event.preventDefault();

// // // //     if (!validateForm()) return;

// // // //     const payload = {
// // // //       issue_id: selectedIssueId,
// // // //       technician_id: selectedTechnicianId,
// // // //     };

// // // //     // Use the verified assignment endpoint
// // // //     axiosClient
// // // //       .post("api/issues/assign/", payload, {
// // // //         headers: {
// // // //           "Content-Type": "application/json",
// // // //           Authorization: `JWT ${token}`,
// // // //         },
// // // //       })
// // // //       .then(() => {
// // // //         setMessage({
// // // //           text: t("Issue assigned to technician successfully"),
// // // //           severity: "success",
// // // //         });
// // // //         setSelectedTechnicianId("");
// // // //         setSelectedIssueId("");
// // // //         setErrors({ issue_id: "", technician_id: "" });
// // // //       })
// // // //       .catch((err) => {
// // // //         console.error("Assignment error:", err);
// // // //         setMessage({ 
// // // //           text: t("Failed to assign. Please ensure the technician is active."), 
// // // //           severity: "error" 
// // // //         });
// // // //       });
// // // //   };

// // // //   const handleClear = () => {
// // // //     setSelectedIssueId("");
// // // //     setSelectedTechnicianId("");
// // // //     setErrors({ issue_id: "", technician_id: "" });
// // // //     setMessage({ text: "", severity: "success" });
// // // //   };

// // // //   return (
// // // //     <Card elevation={16}>
// // // //       <CardContent>
// // // //         <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', mb: 3 }}>
// // // //           {t("TECHNICIAN TO ISSUE")}
// // // //         </Typography>

// // // //         {message.text && (
// // // //           <Alert severity={message.severity} sx={{ mb: 2 }}>
// // // //             {message.text}
// // // //           </Alert>
// // // //         )}

// // // //         <form onSubmit={handleSubmit}>
// // // //           <Box sx={{ "& .MuiFormControl-root": { marginBottom: "1.5rem" } }}>
            
// // // //             {/* SELECT TECHNICIAN */}
// // // //             <FormControl fullWidth variant="outlined" error={!!errors.technician_id}>
// // // //               <InputLabel id="tech-select-label">{t("SELECT TECHNICIAN")}</InputLabel>
// // // //               <Select
// // // //                 labelId="tech-select-label"
// // // //                 value={selectedTechnicianId}
// // // //                 onChange={(e) => setSelectedTechnicianId(e.target.value)}
// // // //                 label={t("SELECT TECHNICIAN")}
// // // //               >
// // // //                 <MenuItem value=""><em>{t("None")}</em></MenuItem>
// // // //                 {technicians.map((tech) => (
// // // //                   <MenuItem key={tech.id} value={tech.id}>
// // // //                     {/* Logic to display the name:
// // // //                         1. Check if there's a nested 'user' or 'custom_user' object
// // // //                         2. Check for direct first_name/last_name
// // // //                         3. Fallback to username or email
// // // //                     */}
// // // //                     {tech.user 
// // // //                         ? `${tech.user.first_name} ${tech.user.last_name}`.trim() || tech.user.username
// // // //                         : tech.first_name 
// // // //                             ? `${tech.first_name} ${tech.last_name}`.trim() 
// // // //                             : tech.username || tech.email || `ID: ${tech.id}`}
// // // //                   </MenuItem>
// // // //                 ))}
// // // //               </Select>
// // // //               {errors.technician_id && <FormHelperText>{errors.technician_id}</FormHelperText>}
// // // //             </FormControl>

// // // //             {/* SELECT ISSUE */}
// // // //             <FormControl fullWidth variant="outlined" error={!!errors.issue_id}>
// // // //               <InputLabel id="issue-select-label">{t("SELECT ISSUE")}</InputLabel>
// // // //               <Select
// // // //                 labelId="issue-select-label"
// // // //                 value={selectedIssueId}
// // // //                 onChange={(e) => setSelectedIssueId(e.target.value)}
// // // //                 label={t("SELECT ISSUE")}
// // // //               >
// // // //                 <MenuItem value=""><em>{t("None")}</em></MenuItem>
// // // //                 {issues.map((issue) => (
// // // //                   <MenuItem key={issue.id} value={issue.id}>
// // // //                     {`#${issue.id}: ${issue.title || issue.description?.substring(0, 30)}`}
// // // //                   </MenuItem>
// // // //                 ))}
// // // //               </Select>
// // // //               {errors.issue_id && <FormHelperText>{errors.issue_id}</FormHelperText>}
// // // //             </FormControl>

// // // //           </Box>

// // // //           <Box sx={{ display: "flex", gap: 2, justifyContent: 'center' }}>
// // // //             <Button type="submit" variant="contained" color="primary" sx={{ px: 4 }}>
// // // //               {t("SUBMIT")}
// // // //             </Button>
// // // //             <Button variant="outlined" color="secondary" onClick={handleClear} sx={{ px: 4 }}>
// // // //               {t("RESET")}
// // // //             </Button>
// // // //           </Box>
// // // //         </form>
// // // //       </CardContent>
// // // //     </Card>
// // // //   );
// // // // };

// // // // export default Staff;

// // // import { useState, useEffect } from "react";
// // // import {
// // //   Card,
// // //   CardContent,
// // //   Typography,
// // //   Button,
// // //   Box,
// // //   FormControl,
// // //   InputLabel,
// // //   MenuItem,
// // //   Select,
// // //   FormHelperText,
// // //   Alert,
// // // } from "@mui/material";
// // // import axiosClient from "../axiosClient";
// // // import { useStateContext } from "../context/ContextProvider";
// // // import { useTranslation } from "react-i18next";

// // // const Staff = () => {
// // //   const [errors, setErrors] = useState({ issue_id: "", technician_id: "" });
// // //   const [selectedIssueId, setSelectedIssueId] = useState("");
// // //   const [selectedTechnicianId, setSelectedTechnicianId] = useState("");
// // //   const [technicians, setTechnicians] = useState([]);
// // //   const [issues, setIssues] = useState([]);
// // //   const [message, setMessage] = useState({ text: "", severity: "success" });
// // //   const { token } = useStateContext();
// // //   const { t } = useTranslation();

// // //   useEffect(() => {
// // //     // Fetch data from verified backend endpoints
// // //     Promise.all([
// // //       axiosClient.get("auth/technicians/"), 
// // //       axiosClient.get("api/issues/"),
// // //     ])
// // //       .then(([techRes, issueRes]) => {
// // //         // Log data to console for debugging
// // //         console.log("Technicians Data Received:", techRes.data);
// // //         setTechnicians(techRes?.data || []);
// // //         setIssues(issueRes?.data || []);
// // //       })
// // //       .catch((err) => {
// // //         console.error("Error fetching data:", err);
// // //         setMessage({
// // //           text: t("Failed to load technicians or issues. Please try again."),
// // //           severity: "error",
// // //         });
// // //       });
// // //   }, [t]);

// // //   const handleSubmit = (event) => {
// // //     event.preventDefault();

// // //     if (!selectedIssueId || !selectedTechnicianId) {
// // //       setErrors({
// // //         issue_id: !selectedIssueId ? t("Issue is required") : "",
// // //         technician_id: !selectedTechnicianId ? t("Technician is required") : "",
// // //       });
// // //       return;
// // //     }

// // //     const payload = {
// // //       issue_id: selectedIssueId,
// // //       technician_id: selectedTechnicianId,
// // //     };

// // //     // Use verified assignment endpoint
// // //     axiosClient
// // //       .post("api/issues/assign/", payload, {
// // //         headers: {
// // //           "Content-Type": "application/json",
// // //           Authorization: `JWT ${token}`,
// // //         },
// // //       })
// // //       .then(() => {
// // //         setMessage({
// // //           text: t("Issue assigned to technician successfully"),
// // //           severity: "success",
// // //         });
// // //         setSelectedTechnicianId("");
// // //         setSelectedIssueId("");
// // //         setErrors({ issue_id: "", technician_id: "" });
// // //       })
// // //       .catch((err) => {
// // //         console.error("Assignment error:", err);
// // //         setMessage({ 
// // //           text: t("Failed to assign. Please ensure the technician is active."), 
// // //           severity: "error" 
// // //         });
// // //       });
// // //   };

// // //   const handleClear = () => {
// // //     setSelectedIssueId("");
// // //     setSelectedTechnicianId("");
// // //     setErrors({ issue_id: "", technician_id: "" });
// // //     setMessage({ text: "", severity: "success" });
// // //   };

// // //   return (
// // //     <Card elevation={16}>
// // //       <CardContent>
// // //         <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', mb: 3 }}>
// // //           {t("TECHNICIAN TO ISSUE")}
// // //         </Typography>

// // //         {message.text && (
// // //           <Alert severity={message.severity} sx={{ mb: 2 }}>
// // //             {message.text}
// // //           </Alert>
// // //         )}

// // //         <form onSubmit={handleSubmit}>
// // //           <Box sx={{ "& .MuiFormControl-root": { marginBottom: "1.5rem" } }}>
            
// // //             {/* SELECT TECHNICIAN - Fixed the 'undefined' labels */}
// // //             <FormControl fullWidth variant="outlined" error={!!errors.technician_id}>
// // //               <InputLabel id="tech-select-label">{t("SELECT TECHNICIAN")}</InputLabel>
// // //               <Select
// // //                 labelId="tech-select-label"
// // //                 value={selectedTechnicianId}
// // //                 onChange={(e) => setSelectedTechnicianId(e.target.value)}
// // //                 label={t("SELECT TECHNICIAN")}
// // //               >
// // //                 <MenuItem value=""><em>{t("None")}</em></MenuItem>
// // //                 {technicians.map((tech) => (
// // //                   <MenuItem key={tech.id} value={tech.id}>
// // //                     {/* Fixed mapping to match your CustomUser model found in SearchUsers */}
// // //                     {tech.first_name ? `${tech.first_name} ${tech.last_name}` : tech.username || `ID: ${tech.id}`}
// // //                   </MenuItem>
// // //                 ))}
// // //               </Select>
// // //               {errors.technician_id && <FormHelperText>{errors.technician_id}</FormHelperText>}
// // //             </FormControl>

// // //             {/* SELECT ISSUE */}
// // //             <FormControl fullWidth variant="outlined" error={!!errors.issue_id}>
// // //               <InputLabel id="issue-select-label">{t("SELECT ISSUE")}</InputLabel>
// // //               <Select
// // //                 labelId="issue-select-label"
// // //                 value={selectedIssueId}
// // //                 onChange={(e) => setSelectedIssueId(e.target.value)}
// // //                 label={t("SELECT ISSUE")}
// // //               >
// // //                 <MenuItem value=""><em>{t("None")}</em></MenuItem>
// // //                 {issues.map((issue) => (
// // //                   <MenuItem key={issue.id} value={issue.id}>
// // //                     {`#${issue.id}: ${issue.title || issue.description?.substring(0, 30)}`}
// // //                   </MenuItem>
// // //                 ))}
// // //               </Select>
// // //               {errors.issue_id && <FormHelperText>{errors.issue_id}</FormHelperText>}
// // //             </FormControl>

// // //           </Box>

// // //           <Box sx={{ display: "flex", gap: 2, justifyContent: 'center' }}>
// // //             <Button type="submit" variant="contained" color="primary" sx={{ px: 4 }}>
// // //               {t("SUBMIT")}
// // //             </Button>
// // //             <Button variant="outlined" color="secondary" onClick={handleClear} sx={{ px: 4 }}>
// // //               {t("RESET")}
// // //             </Button>
// // //           </Box>
// // //         </form>
// // //       </CardContent>
// // //     </Card>
// // //   );
// // // };

// // // export default Staff;

// // import { useState, useEffect } from "react";
// // import {
// //   Card,
// //   CardContent,
// //   Typography,
// //   Button,
// //   Box,
// //   FormControl,
// //   InputLabel,
// //   MenuItem,
// //   Select,
// //   FormHelperText,
// //   Alert,
// // } from "@mui/material";
// // import axiosClient from "../axiosClient";
// // import { useStateContext } from "../context/ContextProvider";
// // import { useTranslation } from "react-i18next";

// // const Staff = () => {
// //   const [errors, setErrors] = useState({ issue_id: "", technician_id: "" });
// //   const [selectedIssueId, setSelectedIssueId] = useState("");
// //   const [selectedTechnicianId, setSelectedTechnicianId] = useState("");
// //   const [technicians, setTechnicians] = useState([]);
// //   const [issues, setIssues] = useState([]);
// //   const [message, setMessage] = useState({ text: "", severity: "success" });
// //   const { token } = useStateContext();
// //   const { t } = useTranslation();

// //   useEffect(() => {
// //     // Fetch data from verified backend endpoints
// //     Promise.all([
// //       axiosClient.get("auth/technicians/"), 
// //       axiosClient.get("api/issues/"),
// //     ])
// //       .then(([techRes, issueRes]) => {
// //         // Log to console to verify structure if names still don't show
// //         console.log("Technicians Data Received:", techRes.data);
// //         setTechnicians(techRes?.data || []);
// //         setIssues(issueRes?.data || []);
// //       })
// //       .catch((err) => {
// //         console.error("Error fetching data:", err);
// //         setMessage({
// //           text: t("Failed to load technicians or issues. Please try again."),
// //           severity: "error",
// //         });
// //       });
// //   }, [t]);

// //   const handleSubmit = (event) => {
// //     event.preventDefault();

// //     if (!selectedIssueId || !selectedTechnicianId) {
// //       setErrors({
// //         issue_id: !selectedIssueId ? t("Issue is required") : "",
// //         technician_id: !selectedTechnicianId ? t("Technician is required") : "",
// //       });
// //       return;
// //     }

// //     const payload = {
// //       issue_id: selectedIssueId,
// //       technician_id: selectedTechnicianId,
// //     };

// //     // POST to verified assignment endpoint
// //     axiosClient
// //       .post("api/issues/assign/", payload, {
// //         headers: {
// //           "Content-Type": "application/json",
// //           Authorization: `JWT ${token}`,
// //         },
// //       })
// //       .then(() => {
// //         setMessage({
// //           text: t("Issue assigned successfully"),
// //           severity: "success",
// //         });
// //         setSelectedTechnicianId("");
// //         setSelectedIssueId("");
// //         setErrors({ issue_id: "", technician_id: "" });
// //       })
// //       .catch((err) => {
// //         console.error("Assignment error:", err.response?.data);
// //         // Display specific backend error if available
// //         const errorMsg = err.response?.data?.detail || t("Failed to assign. Technician may be inactive.");
// //         setMessage({ text: errorMsg, severity: "error" });
// //       });
// //   };

// //   const handleClear = () => {
// //     setSelectedIssueId("");
// //     setSelectedTechnicianId("");
// //     setErrors({ issue_id: "", technician_id: "" });
// //     setMessage({ text: "", severity: "success" });
// //   };

// //   return (
// //     <Card elevation={16}>
// //       <CardContent>
// //         <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', mb: 3 }}>
// //           {t("TECHNICIAN TO ISSUE")}
// //         </Typography>

// //         {message.text && (
// //           <Alert severity={message.severity} sx={{ mb: 2 }}>
// //             {message.text}
// //           </Alert>
// //         )}

// //         <form onSubmit={handleSubmit}>
// //           <Box sx={{ "& .MuiFormControl-root": { marginBottom: "1.5rem" } }}>
            
// //             {/* SELECT TECHNICIAN - Fixes the 'undefined' labels */}
// //             <FormControl fullWidth variant="outlined" error={!!errors.technician_id}>
// //               <InputLabel id="tech-select-label">{t("SELECT TECHNICIAN")}</InputLabel>
// //               <Select
// //                 labelId="tech-select-label"
// //                 value={selectedTechnicianId}
// //                 onChange={(e) => setSelectedTechnicianId(e.target.value)}
// //                 label={t("SELECT TECHNICIAN")}
// //               >
// //                 <MenuItem value=""><em>{t("None")}</em></MenuItem>
// //                 {technicians.map((tech) => (
// //                   <MenuItem key={tech.id} value={tech.id}>
// //                     {/* Maps directly to first/last name as seen in SearchUsers */}
// //                     {tech.first_name ? `${tech.first_name} ${tech.last_name}` : tech.username || `ID: ${tech.id}`}
// //                   </MenuItem>
// //                 ))}
// //               </Select>
// //               {errors.technician_id && <FormHelperText>{errors.technician_id}</FormHelperText>}
// //             </FormControl>

// //             {/* SELECT ISSUE */}
// //             <FormControl fullWidth variant="outlined" error={!!errors.issue_id}>
// //               <InputLabel id="issue-select-label">{t("SELECT ISSUE")}</InputLabel>
// //               <Select
// //                 labelId="issue-select-label"
// //                 value={selectedIssueId}
// //                 onChange={(e) => setSelectedIssueId(e.target.value)}
// //                 label={t("SELECT ISSUE")}
// //               >
// //                 <MenuItem value=""><em>{t("None")}</em></MenuItem>
// //                 {issues.map((issue) => (
// //                   <MenuItem key={issue.id} value={issue.id}>
// //                     {`#${issue.id}: ${issue.title || issue.description?.substring(0, 30)}`}
// //                   </MenuItem>
// //                 ))}
// //               </Select>
// //               {errors.issue_id && <FormHelperText>{errors.issue_id}</FormHelperText>}
// //             </FormControl>

// //           </Box>

// //           <Box sx={{ display: "flex", gap: 2, justifyContent: 'center' }}>
// //             <Button type="submit" variant="contained" color="primary" sx={{ px: 4 }}>
// //               {t("SUBMIT")}
// //             </Button>
// //             <Button variant="outlined" color="secondary" onClick={handleClear} sx={{ px: 4 }}>
// //               {t("RESET")}
// //             </Button>
// //           </Box>
// //         </form>
// //       </CardContent>
// //     </Card>
// //   );
// // };

// // export default Staff;

// import { useState, useEffect } from "react";
// import {
//   Card,
//   CardContent,
//   Typography,
//   Button,
//   Box,
//   FormControl,
//   InputLabel,
//   MenuItem,
//   Select,
//   FormHelperText,
//   Alert,
// } from "@mui/material";
// import axiosClient from "../axiosClient";
// import { useStateContext } from "../context/ContextProvider";
// import { useTranslation } from "react-i18next";

// const Staff = () => {
//   const [errors, setErrors] = useState({ issue_id: "", technician_id: "" });
//   const [selectedIssueId, setSelectedIssueId] = useState("");
//   const [selectedTechnicianId, setSelectedTechnicianId] = useState("");
//   const [technicians, setTechnicians] = useState([]);
//   const [issues, setIssues] = useState([]);
//   const [message, setMessage] = useState({ text: "", severity: "success" });
//   const { token } = useStateContext();
//   const { t } = useTranslation();

//   useEffect(() => {
//     Promise.all([
//       axiosClient.get("auth/technicians/"), 
//       axiosClient.get("api/issues/"),
//     ])
//       .then(([techRes, issueRes]) => {
//         // Log to console to verify the exact structure matches your screenshot
//         console.log("Technicians Data Received:", techRes.data);
//         setTechnicians(techRes?.data || []);
//         setIssues(issueRes?.data || []);
//       })
//       .catch((err) => {
//         console.error("Error fetching data:", err);
//         setMessage({
//           text: t("Failed to load technicians or issues. Please try again."),
//           severity: "error",
//         });
//       });
//   }, [t]);

//   const handleSubmit = (event) => {
//     event.preventDefault();

//     if (!selectedIssueId || !selectedTechnicianId) {
//       setErrors({
//         issue_id: !selectedIssueId ? t("Issue is required") : "",
//         technician_id: !selectedTechnicianId ? t("Technician is required") : "",
//       });
//       return;
//     }

//     // Ensure we are sending the ID field that the backend expects
//     const payload = {
//       issue: selectedIssueId,
//       assigned_to: selectedTechnicianId,
//     };

//     axiosClient
//       .post("api/issues/assign/", payload, {
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `JWT ${token}`,
//         },
//       })
//       .then(() => {
//         setMessage({
//           text: t("Issue assigned successfully"),
//           severity: "success",
//         });
//         setSelectedTechnicianId("");
//         setSelectedIssueId("");
//         setErrors({ issue_id: "", technician_id: "" });
//       })
//       .catch((err) => {
//         console.error("Assignment error details:", err.response?.data);
//         const backendError = err.response?.data?.detail || err.response?.data?.error || t("Failed to assign.");
//         setMessage({ text: backendError, severity: "error" });
//       });
//   };

//   const handleClear = () => {
//     setSelectedIssueId("");
//     setSelectedTechnicianId("");
//     setErrors({ issue_id: "", technician_id: "" });
//     setMessage({ text: "", severity: "success" });
//   };

//   return (
//     <Card elevation={16}>
//       <CardContent>
//         <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', mb: 3 }}>
//           {t("TECHNICIAN TO ISSUE")}
//         </Typography>

//         {message.text && (
//           <Alert severity={message.severity} sx={{ mb: 2 }}>
//             {message.text}
//           </Alert>
//         )}

//         <form onSubmit={handleSubmit}>
//           <Box sx={{ "& .MuiFormControl-root": { marginBottom: "1.5rem" } }}>
            
//             {/* SELECT TECHNICIAN - Fixed Mapping based on your console log */}
//             <FormControl fullWidth variant="outlined" error={!!errors.technician_id}>
//               <InputLabel id="tech-select-label">{t("SELECT TECHNICIAN")}</InputLabel>
//               <Select
//                 labelId="tech-select-label"
//                 value={selectedTechnicianId}
//                 onChange={(e) => setSelectedTechnicianId(e.target.value)}
//                 label={t("SELECT TECHNICIAN")}
//               >
//                 <MenuItem value=""><em>{t("None")}</em></MenuItem>
//                 {technicians.map((tech) => (
//                   <MenuItem key={tech.id} value={tech.id}>
//                     {/* Using the user_first_name and user_last_name keys from your API */}
//                     {tech.user_first_name || tech.user_last_name 
//                       ? `${tech.user_first_name || ''} ${tech.user_last_name || ''}`.trim() 
//                       : `ID: ${tech.id}`}
//                   </MenuItem>
//                 ))}
//               </Select>
//               {errors.technician_id && <FormHelperText>{errors.technician_id}</FormHelperText>}
//             </FormControl>

//             {/* SELECT ISSUE */}
//             <FormControl fullWidth variant="outlined" error={!!errors.issue_id}>
//               <InputLabel id="issue-select-label">{t("SELECT ISSUE")}</InputLabel>
//               <Select
//                 labelId="issue-select-label"
//                 value={selectedIssueId}
//                 onChange={(e) => setSelectedIssueId(e.target.value)}
//                 label={t("SELECT ISSUE")}
//               >
//                 <MenuItem value=""><em>{t("None")}</em></MenuItem>
//                 {issues.map((issue) => (
//                   <MenuItem key={issue.id} value={issue.id}>
//                     {`#${issue.id}: ${issue.title || issue.description?.substring(0, 30)}`}
//                   </MenuItem>
//                 ))}
//               </Select>
//               {errors.issue_id && <FormHelperText>{errors.issue_id}</FormHelperText>}
//             </FormControl>

//           </Box>

//           <Box sx={{ display: "flex", gap: 2, justifyContent: 'center' }}>
//             <Button type="submit" variant="contained" color="primary" sx={{ px: 4 }}>
//               {t("SUBMIT")}
//             </Button>
//             <Button variant="outlined" color="secondary" onClick={handleClear} sx={{ px: 4 }}>
//               {t("RESET")}
//             </Button>
//           </Box>
//         </form>
//       </CardContent>
//     </Card>
//   );
// };

// export default Staff;



import { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Typography,
  Button,
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  FormHelperText,
  Alert,
} from "@mui/material";
import axiosClient from "../axiosClient";
import { useStateContext } from "../context/ContextProvider";
import { useTranslation } from "react-i18next";

const Staff = () => {
  const [errors, setErrors] = useState({ issue_id: "", technician_id: "" });
  const [selectedIssueId, setSelectedIssueId] = useState("");
  const [selectedTechnicianId, setSelectedTechnicianId] = useState("");
  const [technicians, setTechnicians] = useState([]);
  const [issues, setIssues] = useState([]);
  const [message, setMessage] = useState({ text: "", severity: "success" });
  const { token } = useStateContext();
  const { t } = useTranslation();

  useEffect(() => {
    // Fetch Technicians and Issues from verified endpoints
    Promise.all([
      axiosClient.get("auth/technicians/"), 
      // axiosClient.get("api/issues/"),
      axiosClient.get("issues/"),
    ])
      .then(([techRes, issueRes]) => {
        setTechnicians(techRes?.data || []);
        setIssues(issueRes?.data || []);
      })
      .catch((err) => {
        console.error("Error fetching data:", err);
        setMessage({
          text: t("Failed to load data. Please refresh the page."),
          severity: "error",
        });
      });
  }, [t]);

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!selectedIssueId || !selectedTechnicianId) {
      setErrors({
        issue_id: !selectedIssueId ? t("Issue is required") : "",
        technician_id: !selectedTechnicianId ? t("Technician is required") : "",
      });
      return;
    }

    // ✅ PAYLOAD MATCHES BACKEND: technician_user_id
    const payload = {
      issue_id: selectedIssueId,
      technician_user_id: selectedTechnicianId, 
    };

    axiosClient
      .post("api/issues/assign/", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `JWT ${token}`,
        },
      })
      .then(() => {
        setMessage({
          text: t("Issue assigned to technician successfully"),
          severity: "success",
        });
        setSelectedTechnicianId("");
        setSelectedIssueId("");
        setErrors({ issue_id: "", technician_id: "" });
      })
      .catch((err) => {
        console.error("Assignment error details:", err.response?.data);
        // Show the specific error message from the backend
        const backendError = err.response?.data?.error || t("Failed to assign.");
        setMessage({ text: backendError, severity: "error" });
      });
  };

  const handleClear = () => {
    setSelectedIssueId("");
    setSelectedTechnicianId("");
    setErrors({ issue_id: "", technician_id: "" });
    setMessage({ text: "", severity: "success" });
  };

  return (
    <Card elevation={16}>
      <CardContent>
        <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', mb: 3 }}>
          {t("TECHNICIAN TO ISSUE")}
        </Typography>

        {message.text && (
          <Alert severity={message.severity} sx={{ mb: 2 }}>
            {message.text}
          </Alert>
        )}

        <form onSubmit={handleSubmit}>
          <Box sx={{ "& .MuiFormControl-root": { marginBottom: "1.5rem" } }}>
            
            {/* SELECT TECHNICIAN */}
            <FormControl fullWidth variant="outlined" error={!!errors.technician_id}>
              <InputLabel id="tech-select-label">{t("SELECT TECHNICIAN")}</InputLabel>
              <Select
                labelId="tech-select-label"
                value={selectedTechnicianId}
                onChange={(e) => setSelectedTechnicianId(e.target.value)}
                label={t("SELECT TECHNICIAN")}
              >
                <MenuItem value=""><em>{t("None")}</em></MenuItem>
                {technicians.map((tech) => (
                  // ✅ VALUE IS tech.user (The ID the backend expects)
                  <MenuItem key={tech.id} value={tech.user}>
                    {tech.user_first_name || tech.user_last_name 
                      ? `${tech.user_first_name || ''} ${tech.user_last_name || ''}`.trim() 
                      : `ID: ${tech.id}`}
                  </MenuItem>
                ))}
              </Select>
              {errors.technician_id && <FormHelperText>{errors.technician_id}</FormHelperText>}
            </FormControl>

            {/* SELECT ISSUE */}
            <FormControl fullWidth variant="outlined" error={!!errors.issue_id}>
              <InputLabel id="issue-select-label">{t("SELECT ISSUE")}</InputLabel>
              <Select
                labelId="issue-select-label"
                value={selectedIssueId}
                onChange={(e) => setSelectedIssueId(e.target.value)}
                label={t("SELECT ISSUE")}
              >
                <MenuItem value=""><em>{t("None")}</em></MenuItem>
                {issues.map((issue) => (
                  <MenuItem key={issue.id} value={issue.id}>
                    {`#${issue.id}: ${issue.title || issue.description?.substring(0, 30)}`}
                  </MenuItem>
                ))}
              </Select>
              {errors.issue_id && <FormHelperText>{errors.issue_id}</FormHelperText>}
            </FormControl>

          </Box>

          <Box sx={{ display: "flex", gap: 2, justifyContent: 'center' }}>
            <Button type="submit" variant="contained" color="primary" sx={{ px: 4 }}>
              {t("SUBMIT")}
            </Button>
            <Button variant="outlined" color="secondary" onClick={handleClear} sx={{ px: 4 }}>
              {t("RESET")}
            </Button>
          </Box>
        </form>
      </CardContent>
    </Card>
  );
};

export default Staff;